// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const LensDetailsHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.lensDetailsHeader"
        description="Lens details header."
        defaultMessage="Lens Details"
    />
);
LensDetailsHeader.displayName = "LensDetailsHeader";

export const LensDetailsSubHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.lensDetailsSubHeader"
        description="Lens details sub header."
        defaultMessage="Add information to help Snapchatters find your Lens."
    />
);
LensDetailsSubHeader.displayName = "LensDetailsSubHeader";

export const GameLensLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensLabel"
        description="Game lens label."
        defaultMessage="Game Lens"
    />
);
GameLensLabel.displayName = "GameLensLabel";

export const GameLensTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensTooltip"
        description="Game lens tooltip."
        defaultMessage="Game Lenses go through extended moderation and may be reclassified if they do not meet the criteria."
    />
);
GameLensTooltip.displayName = "GameLensTooltip";

export const GameLensDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensDescription"
        description="Game lens description."
        defaultMessage="Game Lenses will be full-screen on Snapchat and can be distributed within the Chat drawer for users to play with friends."
    />
);
GameLensDescription.displayName = "GameLensDescription";

export const GameLensCriteriaLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensCriteriaLinkText"
        description="Game lens criteria link text."
        defaultMessage="criteria"
    />
);
GameLensCriteriaLinkText.displayName = "GameLensCriteriaLinkText";

export const GameLensReviewDescription = (props: { criteriaLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensReviewDescription"
        description="Game lens review description."
        defaultMessage="Game Lenses are evaluated more carefully, so to ensure your Lens meets our core requirements, please check our {criteriaLink}."
        values={props}
    />
);
GameLensReviewDescription.displayName = "GameLensReviewDescription";

export const GameLensPreviewRequirement = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensPreviewRequirement"
        description="Game lens preview requirement."
        defaultMessage="To publish, upload a 5–10s gameplay video to help speed up review."
    />
);
GameLensPreviewRequirement.displayName = "GameLensPreviewRequirement";

export const GameLensInformationTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensInformationTitle"
        description="Game lens information title."
        defaultMessage="Game Lens Information"
    />
);
GameLensInformationTitle.displayName = "GameLensInformationTitle";

export const GameplayPreviewLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameplayPreviewLabel"
        description="Gameplay preview label."
        defaultMessage="Gameplay Preview"
    />
);
GameplayPreviewLabel.displayName = "GameplayPreviewLabel";

export const ChangeGameplayVideoButton = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.changeGameplayVideoButton"
        description="Change gameplay video button."
        defaultMessage="Change Gameplay Video"
    />
);
ChangeGameplayVideoButton.displayName = "ChangeGameplayVideoButton";

export const UploadGameplayVideoButton = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.uploadGameplayVideoButton"
        description="Upload gameplay video button."
        defaultMessage="Upload Gameplay Video"
    />
);
UploadGameplayVideoButton.displayName = "UploadGameplayVideoButton";

export const GameLensInformationDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.gameLensInformationDescription"
        description="Game lens information description."
        defaultMessage="Upload a 5–10s gameplay video showing core mechanics and user interaction. This helps reviewers understand your experience and speeds up moderation. This video will also appear as your Game preview."
    />
);
GameLensInformationDescription.displayName = "GameLensInformationDescription";

export const InvalidPreviewBadge = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.invalidPreviewBadge"
        description="Invalid preview badge."
        defaultMessage="Invalid"
    />
);
InvalidPreviewBadge.displayName = "InvalidPreviewBadge";

export const UpdateMessagePreviousLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.updateMessagePreviousLabel"
        description="Update message previous label."
        defaultMessage="Previous: "
    />
);
UpdateMessagePreviousLabel.displayName = "UpdateMessagePreviousLabel";

export const SubmissionDisclaimerText = (props: {
    privacyPolicyLink: ReactNode;
    lensStudioTermsOfServiceLink: ReactNode;
    termsOfServiceLink: ReactNode;
}): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.submissionDisclaimerText"
        description="Submission disclaimer text."
        defaultMessage="By clicking Submit, I acknowledge that I have read {privacyPolicyLink} and agree to the {lensStudioTermsOfServiceLink} and {termsOfServiceLink}."
        values={props}
    />
);
SubmissionDisclaimerText.displayName = "SubmissionDisclaimerText";

export const PrivacyPolicyLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.privacyPolicyLinkText"
        description="Privacy policy link text."
        defaultMessage="the Privacy Policy"
    />
);
PrivacyPolicyLinkText.displayName = "PrivacyPolicyLinkText";

export const LensStudioTermsOfServiceLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.lensStudioTermsOfServiceLinkText"
        description="Lens studio terms of service link text."
        defaultMessage=" the Lens Studio Terms"
    />
);
LensStudioTermsOfServiceLinkText.displayName = "LensStudioTermsOfServiceLinkText";

export const TermsOfServiceLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensDetails.shared.termsOfServiceLinkText"
        description="Terms of service link text."
        defaultMessage="the Terms of Service"
    />
);
TermsOfServiceLinkText.displayName = "TermsOfServiceLinkText";

export const messages = defineMessages({
    lensTagsLabel: {
        id: "apps.submit.components.lensDetails.shared.lensTagsLabel",
        description: "Lens tags label.",
        defaultMessage: "Snapchat Tags ({curr}/{limit})",
    },
    spectaclesTagsLabel: {
        id: "apps.submit.components.lensDetails.shared.spectaclesTagsLabel",
        description: "Spectacles tags label.",
        defaultMessage: "Spectacles Tags ({curr}/{limit})",
    },
    lensTagsPlaceholder: {
        id: "apps.submit.components.lensDetails.shared.lensTagsPlaceholder",
        description: "Lens tags placeholder.",
        defaultMessage: "Add up to {limit} tags",
    },
    lensTagsTooltip: {
        id: "apps.submit.components.lensDetails.shared.lensTagsTooltip",
        description: "Lens tags tooltip.",
        defaultMessage: "Add descriptive tags to help Snapchatters find your Lens on Snapchat.",
    },
    scanTriggersLabel: {
        id: "apps.submit.components.lensDetails.shared.scanTriggersLabel",
        description: "Scan triggers label.",
        defaultMessage: "Scan Triggers ({curr}/{limit})",
    },
    scanTriggersPlaceholder: {
        id: "apps.submit.components.lensDetails.shared.scanTriggersPlaceholder",
        description: "Scan triggers placeholder.",
        defaultMessage: "Search and add up to {limit} Scan triggers",
    },
    scanTriggersTooltip: {
        id: "apps.submit.components.lensDetails.shared.scanTriggersTooltip",
        description: "Scan triggers tooltip.",
        defaultMessage: "Add scan triggers to help Snapchatters find your Lens via Scan.",
    },
    lensCtaLabel: {
        id: "apps.submit.components.lensDetails.shared.lensCtaLabel",
        description: "Lens cta label.",
        defaultMessage: "Call-to-Action",
    },
    lensCtaTooltip: {
        id: "apps.submit.components.lensDetails.shared.lensCtaTooltip",
        description: "Lens cta tooltip.",
        defaultMessage: "Lens Call-to-Action allows you to direct Snapchatters to your website or app.",
    },
    lensInformationTitle: {
        id: "apps.submit.components.lensDetails.shared.lensInformationTitle",
        description: "Lens information title.",
        defaultMessage: "Lens Information",
    },
    snapchatTagsSectionTitle: {
        id: "apps.submit.components.lensDetails.shared.snapchatTagsSectionTitle",
        description: "Snapchat tags section title.",
        defaultMessage: "Snapchat Tags",
    },
    spectaclesTagsSectionTitle: {
        id: "apps.submit.components.lensDetails.shared.spectaclesTagsSectionTitle",
        description: "Spectacles tags section title.",
        defaultMessage: "Spectacles Tags",
    },
    lensCtaSectionTitle: {
        id: "apps.submit.components.lensDetails.shared.lensCtaSectionTitle",
        description: "Lens cta section title.",
        defaultMessage: "Lens CTA",
    },
    lensOverwritingMessage: {
        id: "apps.submit.components.lensDetails.shared.lensOverwritingMessage",
        description: "Lens overwriting message.",
        defaultMessage: "Overwriting",
    },
    lensDescriptionLabel: {
        id: "apps.submit.components.lensDetails.shared.lensDescriptionLabel",
        description: "Lens description label.",
        defaultMessage: "Description",
    },
    lensDescriptionPlaceholder: {
        id: "apps.submit.components.lensDetails.shared.lensDescriptionPlaceholder",
        description: "Lens description placeholder.",
        defaultMessage: "Add a description of your Lens that will be displayed on the Lens card.",
    },
});
